import { z } from 'zod'

import type { SearchFilterField } from '@/shared/search'

import { classStatuses, deliveryTypes } from '../class-form/class'

/** Where the finding screens live. */
export const findClassesPath = '/classes/classes'
export const findSessionsPath = '/classes/sessions'
export const classSchedulePath = '/classes/schedule'

/** The API's lists. */
export const sessionsApi = '/classes/v1/sessions'
export const scheduleApi = '/classes/v1/schedule'

const summarySchema = z.object({
  id: z.string(),
  name: z.string(),
  courseId: z.string(),
  courseName: z.string(),
  organizationId: z.string(),
  organizationName: z.string(),
  status: z.enum(classStatuses),
  startsOn: z.string(),
  endsOn: z.string(),
  timeZone: z.string(),
  externalId: z.string().nullish(),
  deliveryType: z.enum(deliveryTypes),
  deliveryLanguage: z.string().nullish(),
  minimumStudents: z.number().int(),
  maximumStudents: z.number().int(),
  createdOn: z.string(),
  modifiedOn: z.string(),
  perLearnerPrice: z.number().nullish(),
  perEventPrice: z.number().nullish(),
})

/** A class as Find Classes, the schedule and the chooser list it. */
export type ClassSummary = z.infer<typeof summarySchema>

export function parseClassSummary(item: unknown): ClassSummary {
  return summarySchema.parse(item)
}

const sessionSchema = z.object({
  id: z.string(),
  classId: z.string(),
  className: z.string(),
  courseId: z.string(),
  courseName: z.string(),
  organizationId: z.string(),
  organizationName: z.string(),
  status: z.enum(classStatuses),
  startsOn: z.string(),
  endsOn: z.string(),
  timeZone: z.string(),
  deliveryType: z.enum(deliveryTypes),
})

/** A session as Find Sessions lists it, with its class's columns. */
export type SessionSummary = z.infer<typeof sessionSchema>

export function parseSessionSummary(item: unknown): SessionSummary {
  return sessionSchema.parse(item)
}

/** The status and delivery filters Find Classes, Find Sessions and the schedule share. */
export function statusFilter(labelId = 'classes.find.field.status'): SearchFilterField {
  return {
    id: 'status',
    labelId,
    kind: 'choice',
    options: classStatuses.map((status) => ({ value: status, labelId: `classes.classStatus.${status}` })),
  }
}

export const deliveryFilter: SearchFilterField = {
  id: 'deliveryType',
  labelId: 'classes.find.field.deliveryType',
  kind: 'choice',
  options: deliveryTypes.map((type) => ({ value: type, labelId: `classes.classForm.deliveryType.${type}` })),
}